module.exports = ".container-fluid {\n  min-height: 600px;\n  border-radius: 4px;\n  padding: 30px;\n  background-color: #ffffff;\n  border: solid 1px #c5d0de; }\n  .container-fluid h3 {\n    font-size: 16px;\n    font-weight: 600;\n    text-align: center;\n    color: #4b536b; }\n  .container-fluid p {\n    font-size: 16px;\n    text-align: center;\n    color: #7f8fa4; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/manage/partners/partners.component.scss
// module id = ./src/app/manage/partners/partners.component.scss
// module chunks = main